



























































import Vue from 'vue'

export default Vue.extend({
  name: 'EventCountdown',

  props: {
    startingDate: String,
    runType: String
  },

  data () {
    return {
      startingTime: new Date(this.startingDate).getTime(),
      timeLeft: null! as number,
      countdownInterval: null! as any
    }
  },

  computed: {
    days (): string | number {
      return this.format(Math.floor(this.timeLeft / (1000 * 60 * 60 * 24)))
    },
    hours (): string | number {
      return this.format(Math.floor((this.timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
    },
    minutes (): string | number {
      return this.format(Math.floor((this.timeLeft % (1000 * 60 * 60)) / (1000 * 60)))
    }
  },

  mounted () {
    this.updateCountdown()

    this.countdownInterval = setInterval(() => {
      this.updateCountdown()
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.countdownInterval)
  },

  methods: {
    updateCountdown () {
      this.timeLeft = this.startingTime - new Date().getTime()
    },
    format (value: number) {
      return value.toString().length > 1 ? value : `0${value}`
    }
  }
}
)
